export const ACCOUNTS = {
    package: 'package',
    highEnd: 'highend',
};
